import { render } from "./EmailSendInterface.vue?vue&type=template&id=0817d72d&scoped=true"
import script from "./EmailSendInterface.vue?vue&type=script&lang=js"
export * from "./EmailSendInterface.vue?vue&type=script&lang=js"

import "./EmailSendInterface.vue?vue&type=style&index=0&id=0817d72d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0817d72d"]])

export default __exports__